import {Component} from '@angular/core';
import {Observable} from "rxjs";
import {Field} from "../field";
import {DetailService} from "../../../../services/details/detail.service";

@Component({
  selector: 'tig-reload',
  template: ``
})
export class ReloadComponent extends Field
{
  
  
  /**
   * Attributes
   */
  OBJ_observable_external_data: Observable<void>;
  
  
  /**
   * Function > constructor
   * @param {DetailService} OBJ_detail_service
   */
  constructor(protected OBJ_detail_service: DetailService)
  {
    super();
  } // end function constructor
  

} // end class ReloadComponent